import { render, staticRenderFns } from "./machiningDetail.vue?vue&type=template&id=1b9e5d64&scoped=true&"
import script from "./machiningDetail.vue?vue&type=script&lang=js&"
export * from "./machiningDetail.vue?vue&type=script&lang=js&"
import style0 from "./machiningDetail.vue?vue&type=style&index=0&id=1b9e5d64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9e5d64",
  null
  
)

export default component.exports